import { render } from "./ReorderCustomListsModal.vue?vue&type=template&id=613af833&scoped=true"
import script from "./ReorderCustomListsModal.vue?vue&type=script&lang=js"
export * from "./ReorderCustomListsModal.vue?vue&type=script&lang=js"

import "./ReorderCustomListsModal.vue?vue&type=style&index=0&id=613af833&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613af833"]])

export default __exports__